// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-negated-condition, init-declarations */
export const getScrollingElement = () =>
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  window.document.scrollingElement || window.document.documentElement

export const getScrollTop = () => {
  const scrollingElement = getScrollingElement()
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return scrollingElement != null ? scrollingElement.scrollTop : 0
}

export const getElementPosition = (_element: HTMLElement | string) => {
  const scrollTop = getScrollTop()
  let element
  if (typeof _element === "string") {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    element = window.document.body != null ? window.document.body.querySelector(_element) : null
  } else {
    element = _element
  }

  if (!element) return null

  const offsets = element.getBoundingClientRect()

  return {
    top: offsets.top + scrollTop,
    left: offsets.left,
    bottom: offsets.bottom + scrollTop,
    right: offsets.right,
  }
}

export const hasBlockedScroll = () => {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (window.document.body != null) {
    return window.document.body.classList.contains("_noscroll")
  }
  return false
}

const getBody = () => window.document.body

const getNavBar = () => {
  const bodyElement = getBody()
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return bodyElement != null
    ? // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      bodyElement.querySelector(".NitroNavBar > nav") ||
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        bodyElement.querySelector(".NitroNavBar > div") ||
        bodyElement.querySelector(".PagesNavbar")
    : null
}

export const getNavBarHeight = () => {
  const NavBar = getNavBar()

  if (!NavBar) return 0

  return NavBar.clientHeight
}

export const getMovedTop = () => {
  const bodyElement = getBody()
  const NavBar = getNavBar()

  if (!NavBar) return 0

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const MainView = bodyElement != null ? bodyElement.querySelector(".MainView") : null

  // @ts-expect-error: Flow to TS migration.
  let movedTop = MainView != null ? -parseFloat(MainView.style.top) : 0

  const NavBarStyles = window.getComputedStyle(NavBar)

  if (NavBarStyles.position === "fixed") {
    movedTop += NavBar.clientHeight
  }

  return movedTop
}

export const handleBlockScrollBody = (
  block: boolean,
  callback?: (...args: unknown[]) => void,
  extraBodyClass?: string,
): void => {
  if (typeof document === "undefined") return

  const noScrollClasses = ["_noscroll"]
  if (extraBodyClass != null) {
    // FIXME: a method has been detected that possibly mutates the object, consider a more
    // functional approach (Ramda might help)

    noScrollClasses.push(extraBodyClass)
  }

  const bodyElement = getBody()
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (bodyElement == null) return

  const MainView = bodyElement.querySelector(".MainView")
  if (block) {
    if (!bodyElement.classList.contains("_noscroll")) {
      const scrollTop =
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        window.pageYOffset !== undefined
          ? window.pageYOffset
          : // Fix this the next time the file is edited. (Flow to TS)
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            (document.documentElement || bodyElement.parentElement || bodyElement).scrollTop
      let movedTop = -scrollTop

      const NavBar = getNavBar()
      if (NavBar != null) {
        const NavBarStyles = window.getComputedStyle(NavBar)
        if (NavBarStyles.position === "fixed") {
          movedTop += NavBar.clientHeight
        }
      }

      if (MainView) {
        // @ts-expect-error: Flow to TS migration.
        MainView.style.top = `${movedTop}px`
      }

      bodyElement.classList.add(...noScrollClasses)
    }
  } else {
    if (!bodyElement.classList.contains("_noscroll")) return

    bodyElement.classList.remove(...noScrollClasses)
    const movedTop = getMovedTop()

    if (MainView) {
      // @ts-expect-error: Flow to TS migration.
      MainView.style.top = ""
    }

    if (window.document.scrollingElement != null) {
      window.document.scrollingElement.scrollTop = movedTop
    }

    if (callback) {
      callback()
    }
  }
}

export function addScrollHandler(onScrollFunction: () => void, element: Node = document) {
  element.addEventListener("touchmove", onScrollFunction, false)
  element.addEventListener("scroll", onScrollFunction, false)
}

export function removeScrollHandler(onScrollFunction: () => void, element: Node = document) {
  element.removeEventListener("touchmove", onScrollFunction)
  element.removeEventListener("scroll", onScrollFunction)
}

export function adjustScrollHelper(
  direction: string,
  place: HTMLElement | null | undefined,
  node: HTMLElement,
) {
  const placeHeight = place ? place.offsetHeight : 0
  const offsetTop = place ? place.offsetTop : 0

  const modalHeight = node.offsetHeight
  const pickerHeight = modalHeight - placeHeight

  let position
  let difference
  if (direction === "down") {
    position = offsetTop - pickerHeight
    difference = node.scrollTop - position > modalHeight

    if (position > node.scrollTop || difference) {
      return position
    }
  } else {
    position = offsetTop
    difference = node.scrollTop - position < -modalHeight + placeHeight * 2

    if (position < node.scrollTop || difference) {
      return position
    }
  }
  return undefined
}

export function scrollTo(x: number, y: number) {
  try {
    window.scroll({ top: y, behavior: "smooth" })
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    // needed here, scroll is in window, but with different signature in electron browser / cypress
    if (err.message.includes("Failed to execute 'scroll' on 'Window'")) {
      window.scroll(x, y) // signature with options object might not be supported - scrollTo works aswell
    } else {
      throw err
    }
  }
}

export type RtlScrollLeftMode = "normal" | "negative" | "reverse"

export function guessScrollLeftMode(element: HTMLElement, isRtl: boolean): RtlScrollLeftMode {
  if (!isRtl) {
    return "normal"
  }

  const scrollLeftBefore = element.scrollLeft

  element.scrollLeft = -1

  const { scrollLeft } = element

  element.scrollLeft = scrollLeftBefore

  if (scrollLeft < 0) {
    return "negative"
  }

  return scrollLeftBefore > 0 ? "reverse" : "normal"
}

export function getScrollLeft(element: HTMLElement, mode: RtlScrollLeftMode) {
  const { scrollLeft } = element

  if (mode === "reverse") {
    const max = element.scrollWidth - element.clientWidth

    return max - scrollLeft
  }

  return Math.abs(scrollLeft)
}

export function updateScrollLeftBy(
  element: HTMLElement,
  diff: number,
  mode: RtlScrollLeftMode,
  _scrollLeft: number | null = null,
): number {
  const scrollLeft = _scrollLeft === null ? getScrollLeft(element, mode) : _scrollLeft
  const newScrollLeft = scrollLeft + diff

  if (mode === "reverse") {
    const max = element.scrollWidth - element.clientWidth

    return max - newScrollLeft
  }

  return mode === "negative" ? -newScrollLeft : newScrollLeft
}
